// Rutas del módulo Automatizaciones: una sola vista de solo lectura con el
// estado de las tareas programadas (crons) del portal.
export default [
  {
    path: '',
    name: 'automatizaciones',
    component: () => import(/* webpackChunkName: "automatizaciones" */ '@/apps/automatizaciones/pages/AutomatizacionesPage.vue'),
  },
]
